import React from "react";
import "../../Styles/certified/adam.css";

export default function Finzly() {
  return (
    <>
      <div className="adam-certified-details-section">
        <div className="adam-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="adam-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="adam-certified-details-left">
            <img
              src="/assets/adam/adam_ribbon.png"
              alt="Outstanding Workplaces Certified"
              className="adam-certified-badge"
            />
            <div className="adam-certified-company-names">
              <a href="https://adamsbridge.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/adam/adam.png"
                alt="Walkzero Logo"
                className="adam-certified-company-logo"
              />
            </a>
              <h1 className="adam-certified-full-name">
            Adamsbridge Services Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="adam-certified-details-right">
            <img
              src="/assets/adam/adam_5.jpg"
              alt="Finzly Office"
              className="adam-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="adam-certified-description">
          <h2>
            Why  Adamsbridge Services Private Limited is an Outstanding Workplaces
          </h2>
          <p>
            adamsbridge is a global technology and professional services organization to help businesses simplify complex operations, improve efficiency, and scale effectively across Insurance & Healthcare, Real Estate, Accounting, Legal Services, and Technology. adamsbridge's capabilities span AI-powered solutions, data analytics, medical record retrieval and summarization, underwriting and claims support, back-office operations, real estate services, lease and portfolio management, accounting support, and technology platforms. Its approach combines purpose-built technology with experienced teams to automate manual work, improve accuracy, and streamline workflows.

          </p>
          
        </div>
        {/* Info Cards Section */}
        <div className="adam-certified-info-cards">
          <div className="adam-certified-info-card">
            <div className="adam-certified-info-title">COMPANY SIZE</div>
            <div className="adam-certified-info-value">1900+ Employees</div>
          </div>
          <div className="adam-certified-info-card">
            <div className="adam-certified-info-title">INDUSTRY</div>
            <div className="adam-certified-info-value">KPO


</div>
          </div>
          <div className="adam-certified-info-card">
            <div className="adam-certified-info-title">CONNECT</div>
            <div className="adam-certified-info-icons">
              <span className="adam-certified-icon-round">
                <a href="https://adamsbridge.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="adam-certified-icon-round">
                <a href="https://www.linkedin.com/company/adams-bridge-global/posts/?feedView=all" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              
            </div>
          </div>
          <div className="adam-certified-info-card">
            <div className="adam-certified-info-title">LOCATION (HQ)</div>
            <div className="adam-certified-info-value">Chennai </div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="adam-certified-recognition-section">
          <h2 className="adam-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="adam-certified-recognition-badge">
            <img
              src="/assets/adam/adam_ribbon.png"
              alt="Outstanding Workplaces Certified"
              className="adam-certified-recognition-image"
            />
          </div>
          <div className="adam-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="adam-certified-life-section">
          <h2 className="adam-certified-life-title">
            Life at  Adamsbridge Services Private Limited
          </h2>
          <div className="adam-certified-life-gallery">
            <div className="adam-certified-life-col">
              <img src="/assets/adam/adam_2.jpg" alt="Office 1" className="adam-certified-life-img" />
              <img src="/assets/adam/adam_3.jpg" alt="Team 1" className="adam-certified-life-img" />
            </div>
            <div className="icom-certified-life-col adam-certified-life-center">
              <img src="/assets/adam/adam_1.jpg" alt="Main Office" className="adam-certified-life-img adam-certified-life-img-large" />
            </div>
            <div className="adam-certified-life-col">
              <img src="/assets/adam/adam_4.jpg" alt="Office 2" className="adam-certified-life-img" />
              <img src="/assets/adam/adam_6.jpg" alt="Team 2" className="adam-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
